import { Content } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { createTitle } from "@/functions/createTitle";
import { jobs_helper } from "@/helpers/jobs_helper";
import { branch_helper } from "@/helpers/branch_helper";
import * as additionalComponents from "./__components";

const defaultConfig = {
  titleKey: "title",
  descriptionKey: "description",
  imgKey: "header_image",
  headerTextColorKey: "header_text_color",
  headerBackgroundColorKey: "header_background_color",
  headerImagePositionKey: "header_image_position",
};

export default function BranchPage({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { config: __config, url_slug } }) {
  const config = Object.assign({}, defaultConfig, __config);
  const branch = branch_helper.find(url_slug);
  const jobs = jobs_helper.filter((i) => JSON.stringify(i).includes(branch.id));

  return {
    props: {
      meta: { title: createTitle(branch.name, "Our Branches") },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              { label: "Contact us", href: getRoute("contact") },
              { label: "Our Branches", href: getRoute("branches") },
              { label: branch.name, href: getRoute("", { url_slug }).replace(/\/$/, "") },
            ],
          },
        },
        {
          component: "Header",
          props: {
            title: { path: `page.branch.${url_slug}.component.Header.title`, placeholder: `${branch.name} Branch` },
            back: {
              path: "page.branch.component.Header.back",
              placeholder: `Back to branches`,
              href: getRoute("branches"),
            },
            img: branch[config.imgKey] ?? null,
            variant: branch[config.headerImagePositionKey] ?? "Under Text",
          },
        },
        { component: "BranchPageContent", props: { ...branch } },
        ...(jobs.length > 0
          ? [
              { component: "Divider" },
              {
                component: "LatestJobs",
                props: {
                  title: null, // `Latest Jobs in ${branch.name}`,
                  items: jobs,
                  visibleCount: 4,
                },
              },
            ]
          : []),
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: branch_helper.toPaths(),
    fallback: false,
  };
}
